module.exports = __webpack_public_path__ + "img/icon3@2x.50379885.png";